import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export default function ModpackCarousel({ images }) {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
  };

  return (
    <Slider {...settings}>
      {images.map((img, idx) => (
        <div key={idx} className="overflow-hidden rounded-lg">
          <img
            src={img}
            alt={`Slide ${idx + 1}`}
            className="w-full h-48 object-cover transition-transform duration-500 ease-in-out transform hover:scale-105"
          />
        </div>
      ))}
    </Slider>
  );
}
